export default __webpack_public_path__ + "static/media/IPhone15Mockup.48bba781.png";